/**
 * Generated by orval 🍺
 * Do not edit manually.
 * standard public schema
 * OpenAPI spec version: 16.1
 */
import type {
  DeleteEpaFuelEfficiencyRatingsParams,
  EpaFuelEfficiencyRatings,
  EpaFuelEfficiencyRatingsInsertPayload,
  EpaFuelEfficiencyRatingsUpdate,
  GetEpaFuelEfficiencyRatingsParams,
  PatchEpaFuelEfficiencyRatingsParams,
  PostEpaFuelEfficiencyRatingsParams,
  PostgrestError
} from '../../models';

import {
  backendBaseUrl
} from '@/api/vtnz-backend/baseUrl';


export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

export type getEpaFuelEfficiencyRatingsResponse200 = {
  data: EpaFuelEfficiencyRatings[]
  status: 200
}

export type getEpaFuelEfficiencyRatingsResponse206 = {
  data: EpaFuelEfficiencyRatings[]
  status: 206
}

export type getEpaFuelEfficiencyRatingsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200 | 206>
}

export type getEpaFuelEfficiencyRatingsResponseSuccess = (getEpaFuelEfficiencyRatingsResponse200 | getEpaFuelEfficiencyRatingsResponse206) & {
  headers: Headers;
};
export type getEpaFuelEfficiencyRatingsResponseError = (getEpaFuelEfficiencyRatingsResponseDefault) & {
  headers: Headers;
};

export type getEpaFuelEfficiencyRatingsResponse = (getEpaFuelEfficiencyRatingsResponseSuccess | getEpaFuelEfficiencyRatingsResponseError)

export const getGetEpaFuelEfficiencyRatingsUrl = (params?: GetEpaFuelEfficiencyRatingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/epa_fuel_efficiency_ratings?${stringifiedParams}` : `${backendBaseUrl}/epa_fuel_efficiency_ratings`
}

/**
 * @summary Read rows from `epa_fuel_efficiency_ratings`.
 */
export const getEpaFuelEfficiencyRatings = async (params?: GetEpaFuelEfficiencyRatingsParams, options?: RequestInit): Promise<getEpaFuelEfficiencyRatingsResponse> => {

  const res = await fetch(getGetEpaFuelEfficiencyRatingsUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getEpaFuelEfficiencyRatingsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getEpaFuelEfficiencyRatingsResponse
}


export type postEpaFuelEfficiencyRatingsResponse201 = {
  data: EpaFuelEfficiencyRatings[]
  status: 201
}

export type postEpaFuelEfficiencyRatingsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 201>
}

export type postEpaFuelEfficiencyRatingsResponseSuccess = (postEpaFuelEfficiencyRatingsResponse201) & {
  headers: Headers;
};
export type postEpaFuelEfficiencyRatingsResponseError = (postEpaFuelEfficiencyRatingsResponseDefault) & {
  headers: Headers;
};

export type postEpaFuelEfficiencyRatingsResponse = (postEpaFuelEfficiencyRatingsResponseSuccess | postEpaFuelEfficiencyRatingsResponseError)

export const getPostEpaFuelEfficiencyRatingsUrl = (params?: PostEpaFuelEfficiencyRatingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/epa_fuel_efficiency_ratings?${stringifiedParams}` : `${backendBaseUrl}/epa_fuel_efficiency_ratings`
}

/**
 * @summary Insert one or more rows into `epa_fuel_efficiency_ratings`.
 */
export const postEpaFuelEfficiencyRatings = async (epaFuelEfficiencyRatingsInsertPayload: EpaFuelEfficiencyRatingsInsertPayload,
    params?: PostEpaFuelEfficiencyRatingsParams, options?: RequestInit): Promise<postEpaFuelEfficiencyRatingsResponse> => {

  const res = await fetch(getPostEpaFuelEfficiencyRatingsUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(epaFuelEfficiencyRatingsInsertPayload)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postEpaFuelEfficiencyRatingsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as postEpaFuelEfficiencyRatingsResponse
}


export type patchEpaFuelEfficiencyRatingsResponse200 = {
  data: EpaFuelEfficiencyRatings[]
  status: 200
}

export type patchEpaFuelEfficiencyRatingsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type patchEpaFuelEfficiencyRatingsResponseSuccess = (patchEpaFuelEfficiencyRatingsResponse200) & {
  headers: Headers;
};
export type patchEpaFuelEfficiencyRatingsResponseError = (patchEpaFuelEfficiencyRatingsResponseDefault) & {
  headers: Headers;
};

export type patchEpaFuelEfficiencyRatingsResponse = (patchEpaFuelEfficiencyRatingsResponseSuccess | patchEpaFuelEfficiencyRatingsResponseError)

export const getPatchEpaFuelEfficiencyRatingsUrl = (params?: PatchEpaFuelEfficiencyRatingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/epa_fuel_efficiency_ratings?${stringifiedParams}` : `${backendBaseUrl}/epa_fuel_efficiency_ratings`
}

/**
 * @summary Update the rows of `epa_fuel_efficiency_ratings` matching the given filters.
 */
export const patchEpaFuelEfficiencyRatings = async (epaFuelEfficiencyRatingsUpdate: EpaFuelEfficiencyRatingsUpdate,
    params?: PatchEpaFuelEfficiencyRatingsParams, options?: RequestInit): Promise<patchEpaFuelEfficiencyRatingsResponse> => {

  const res = await fetch(getPatchEpaFuelEfficiencyRatingsUrl(params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(epaFuelEfficiencyRatingsUpdate)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: patchEpaFuelEfficiencyRatingsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as patchEpaFuelEfficiencyRatingsResponse
}


export type deleteEpaFuelEfficiencyRatingsResponse200 = {
  data: EpaFuelEfficiencyRatings[]
  status: 200
}

export type deleteEpaFuelEfficiencyRatingsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type deleteEpaFuelEfficiencyRatingsResponseSuccess = (deleteEpaFuelEfficiencyRatingsResponse200) & {
  headers: Headers;
};
export type deleteEpaFuelEfficiencyRatingsResponseError = (deleteEpaFuelEfficiencyRatingsResponseDefault) & {
  headers: Headers;
};

export type deleteEpaFuelEfficiencyRatingsResponse = (deleteEpaFuelEfficiencyRatingsResponseSuccess | deleteEpaFuelEfficiencyRatingsResponseError)

export const getDeleteEpaFuelEfficiencyRatingsUrl = (params?: DeleteEpaFuelEfficiencyRatingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/epa_fuel_efficiency_ratings?${stringifiedParams}` : `${backendBaseUrl}/epa_fuel_efficiency_ratings`
}

/**
 * @summary Delete the rows of `epa_fuel_efficiency_ratings` matching the given filters.
 */
export const deleteEpaFuelEfficiencyRatings = async (params?: DeleteEpaFuelEfficiencyRatingsParams, options?: RequestInit): Promise<deleteEpaFuelEfficiencyRatingsResponse> => {

  const res = await fetch(getDeleteEpaFuelEfficiencyRatingsUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteEpaFuelEfficiencyRatingsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteEpaFuelEfficiencyRatingsResponse
}


